module.exports = __webpack_public_path__ + "images/Okta-8dac18.png";